export const emulateClick = (event: Event): void => {
  (event.target as HTMLElement).click();
};
